/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// ghost: forces the frontend pipeline to redeploy (dev bf33fb148 was lambdas-only,
// so the freeze/watchdog frontend changes from the prior commit weren't picked up).
